import { createFileRoute } from '@tanstack/react-router';
import EvBatteryKwOnline from '../../../components/Graphs/EvBatteryKw';

export const Route = createFileRoute('/_authenticated/graphs/ev-battery-abs/$vehicleId')({
  beforeLoad: ({ context }) => {
    // requirePermission(PERMISSION_RIDES, ['read']);
    return {
      ...context,
      documentTitle: {
        main: 'enum.onlineMap.widget.types.evBattery',
        params: { valueType: 'kWh' },
        // suffix: 'menu.overviewTours',
      },
      isMenuDisabled: true,
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: EvBatteryAbsGraphRoute,
});

function EvBatteryAbsGraphRoute() {
  const { vehicleId } = Route.useParams();

  return <EvBatteryKwOnline vehicleId={Number(vehicleId)} isPage />;
}
